import { FlightEventHandler, registerEventHandlerClass } from './flight'
import { api } from '../api'
import { writable } from 'svelte/store'

export default class GrsDevices extends FlightEventHandler {
	apiDevices = {}
	devices = {}

	constructor(flight) {
		super(flight)

		const { subscribe, set, update } = writable({});
		this.subscribe = subscribe 
		this.set = set
		this.update = update

		api.devices.get()
		this.deviceUnsubscribe = api.devices.store.subscribe(d => {
			this.apiDevices = d
		})

		this.serverStateUnsubscribe = flight.serverStateStore.subscribe(state => {
			for(const link of state.links) {
				for(const id of link.grsDeviceIds) {
					if (!this.devices[id] && this.apiDevices[id]) {
						// we must have added a grs or new link or something...
						this.devices[id] = this.apiDevices[id]
					}
				}
			}
			this.set(this.devices)
		})
	}

	handleKeyframe(keyframe) {
		const old = this.devices
		this.devices = JSON.parse(JSON.stringify(keyframe.grsDevices))
		if (keyframe.radioState) {
			for (const key of Object.keys(keyframe.radioState)) {
				const data = keyframe.radioState[key]
				this.devices[key].userSocket = data.user
				this.devices[key].controlSocket = data.control
				this.devices[key].roamingState = data.rs
				this.devices[key].latency = data.latency
			}
		}
		for (const id in old) {
			if (this.devices[id]) this.devices[id].selected = old[id].selected
		}
		this.set(this.devices)
	}

	processStatus(message) {
		const deviceId = message.data.localSource.deviceId

		// TODO: is this the right thing to do?
		if (message.data.local.position.latitude === 0 && message.data.local.position.longitude === 0) return

		const d = this.devices[deviceId]
		if (!d) {
			console.error('Got an update for an unknown device', deviceId)
			return
		}
		d.latitude = message.data.local.position.latitude
		d.longitude = message.data.local.position.longitude
		d.remoteRadioStatus = message.data.remote.protocol.radioStatus
		d.status = message.data.remote.protocol.radioStatus ? '' : 'No Signal'
		d.isLead = message.data.local.isLead

		if (message.data.remote.protocol.radioStatus > 0 && message.data.remote.position.latitude && message.data.remote.position.longitude) {
			d.lastArsLocation = [message.data.remote.position.latitude, message.data.remote.position.longitude]
		}

		d.lastStatus = message.data
	}

	processDMRadioMessage(message) {
		if (!message.deviceId) return
		const device = this.devices[message.deviceId]
		if (!device) return

		switch (message.type) {
			case 'GRS_USER_UP':
				device.userSocket = true
				break
			case 'GRS_USER_DOWN':
				device.userSocket = false
				break
			case 'GRS_CTRL_UP':
				device.controlSocket = true
				break
			case 'GRS_CTRL_DOWN':
				device.controlSocket = false
				break
			case 'GRS_ROAMING':
				device.roamingState = "roaming"
				break
			case 'GRS_TRUANT':
				device.roamingState = "truant"
				break
			case 'GRS_ACTIVE':
				device.roamingState = "active"
				break
			case 'GRS_QUALIFIED':
				device.roamingState = "qualified"
				break
			case 'GRS_TRACKING':
				device.roamingState = "tracking"
				break
			case 'LINK_LATENCY':
				device.latency = message.measured
				break
			case 'GRS_STOPPING':
			case 'GRS_STOPPED':
			default:
				return
		}
	}

	handleFlightStep(message) {
		switch(message.type) {
			case 'SKYLINK_ADV_STATUS':
				this.processStatus(message)
				this.set(this.devices)
				break;
			case 'GRS_USER_UP':
			case 'GRS_CTRL_UP':
			case 'GRS_USER_DOWN':
			case 'GRS_CTRL_DOWN':
			case 'GRS_ROAMING':
			case 'GRS_TRUANT':
			case 'LINK_LATENCY':
			case 'GRS_TRACKING':
			case 'GRS_ACTIVE':
			case 'GRS_QUALIFIED':
			case 'GRS_STOPPING':
			case 'GRS_STOPPED':
			// TODO:  New ARS and error messages
				this.processDMRadioMessage(message)
				this.set(this.devices)
				break;
			
		}
	}

	cleanup() {
		super.cleanup()

		if (this.deviceUnsubscribe) {
			this.deviceUnsubscribe()
		}
		if (this.serverStateUnsubscribe) {
			this.serverStateUnsubscribe()
		}
	}
}

registerEventHandlerClass(GrsDevices)